import apiClient from "../axios";

function postRedemptions(data) {
  return apiClient.post("/redemptions", data);
}

function postRedemptionForm(data) {
  return apiClient.post("/redemptionform", data);
}

// function getRedemptionForm(id) {
//     return apiClient.get(`/redemptionform/${id}`);
// }

export { postRedemptions, postRedemptionForm };
